//#region Styles
import { Circle, Container } from "./styles";
//#endregion

const Caption = ({
    label,
    color,
    borderColor
}) => {
    return (
        <Container>
            <span>{label}</span>
            <Circle color={color} borderColor={borderColor}/>
        </Container>
    );
}

export default Caption;